import * as React from 'react';
import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';

import { withClassname } from '@components/hoc/withClassname';
import { HistoryForm } from '@modules/history/HistoryForm';

import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const historyUrl = '/metropolis/api/historyEntityDto';
export const historyLabel = 'Historie';
export const historyPath = '/history';
export const HistoryGrid = compose(
  withRouter,
  setDisplayName('HistoryGrid'),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: historyLabel }]),
  withColumns(Agenda.HISTORY),
  withProps(({ columns }) => ({
    name: 'HistoryGrid',
    url: historyUrl,
    Form: HistoryForm,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: true,
      pageSize: 50,
      version: 3,
      ActionBar: () => <ColumnManager agenda={Agenda.HISTORY} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/history/HistoryGrid.tsx